<template>
  <section class="subject-card">
    <router-link :to="`/subjectDetail/${item.id}/home`">
      <img :src="item.thumb | imageUrl('', 320,320)" alt />
      <span class="title">{{item.title}}</span>
    </router-link>
  </section>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.subject-card {
  a {
    display: flex;
    flex-direction: column;

    img {
      width: 160px;
      height: 160px;
    }

    span {
      padding-top: 15px;
      font-size: 15px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      line-height: 21px;
      max-height: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      color: #333;

      &:hover {
        color: #0A0A0A;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/v2/peopleCenter/SubjectCard.vue